module.exports = __webpack_public_path__ + "img/plan-first-responder.87648d1.png";